module.exports = __webpack_public_path__ + "static/img/comtop-four.e9cb35a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/comtop-four.png
// module id = /8tt
// module chunks = 0